module.exports = __webpack_public_path__ + "static/media/al.a07d2864.svg";